import { apiComplete, apiStart } from "./api";
import axiosBackend from "../../config/axios/axios-back-end";
import { message } from "antd";

export const bulkfilemappingGetHmgMapping = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackend.get(
        `/api/bulkfilemapping/hmgfilemapping/${id}`,
        null,
        { "Content-Type": "application/json" }
      );
      dispatch(apiComplete());
      return Array.isArray(result.data.hotels) ? result.data.hotels : [];
    } catch (error) {
      console.log(error);
      dispatch(apiComplete());
      return [];
    }
  };
};

export const bulkfilemappingCreate = (params) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackend.post("/api/bulkfilemapping/", params, {
        "Content-Type": "application/json",
      });
      message.success("Bulk File Mapping Names addes Successfully");
      dispatch(apiComplete());
      return true;
    } catch (error) {
      console.log(error);
      message.error(
        typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error"
      );
      dispatch(apiComplete());
      return false;
    }
  };
};

export const bulkfilemappingGetHotelData = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackend.get(
        `/api/bulkfilemapping/gethotelfiles/${id}`,
        null,
        { "Content-Type": "application/json" }
      );
      dispatch(apiComplete());
      return result.data.data;
    } catch (error) {
      console.log(error, "get dta error");
      dispatch(apiComplete());
      return [];
    }
  };
};

export const bulkfilemappingUpdateBulkFile = (params) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackend.put(
        `/api/bulkfilemapping/${params._id}`,
        params,
        { "Content-Type": "application/json" }
      );
      dispatch(apiComplete());
      message.success("Bulk File Updated Successfully");
      return true;
    } catch (error) {
      dispatch(apiComplete());
      console.log(error);
      message.error(
        typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error"
      );
      return false;
    }
  };
};

export const bulkfilemappingDelete = (params) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      dispatch(apiComplete());
      const result = await axiosBackend.post(
        `/api/bulkfilemapping/delete`,
        params,
        { "Content-Type": "application/json" }
      );
      // console.log(result,'api result');
      message.success("Bulk File Deleted Successfully");
      return true;
    } catch (error) {
      dispatch(apiComplete());
      console.log(error);
      message.error(
        typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error"
      );
      return false;
    }
  };
};
